import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaximizeDialogButtonComponent } from '@portal-core/general/components/maximize-dialog-button/maximize-dialog-button.component';
import { LifeCycleModule } from '@portal-core/general/directives/life-cycle/life-cycle.module';

@NgModule({
  declarations: [MaximizeDialogButtonComponent
  ],
  imports: [
    CommonModule,
    LifeCycleModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    MaximizeDialogButtonComponent
  ]
})
export class MaximizeDialogButtonModule { }
